import { DateTime } from "../../types";


export function getDateTime(date: number | string | Date = new Date()): DateTime {
    if (typeof date === "string" || typeof date === "number")
        date = new Date(date);

    return Math.floor(date.getTime() / 1000);
}
export function getWeekDay(dateTime: DateTime) {
    const date = new Date(dateTime * 1000);
    return date.getDay();
}
export function getStockBeforeDay(dateTime?: DateTime) {
    if (!dateTime) dateTime = getDateTime();

    const weekDay = getWeekDay(dateTime);

    return weekDay <= 1 // sunday and monday
        ? startDay(addDay(dateTime, -2 - weekDay))
        : startDay(addDay(dateTime, -1));
}

export function formatDay(dateTime: DateTime) {
    const date = new Date(dateTime * 1000);
    return date.toISOString().slice(0, 10);
}
export function formatTime(dateTime: DateTime) {
    const date = new Date(dateTime * 1000);
    return date.toISOString().slice(0, 16).slice(11);
}
export function formatDateTime(dateTime: DateTime) {
    return formatDay(dateTime) + " " + formatTime(dateTime);
}
export function formatISO(dateTime: DateTime) {
    return new Date(dateTime * 1000).toISOString();
}
export function formatWeekDay(dateTime: DateTime, short = false) {
    const weekDayFormatter = new Intl.DateTimeFormat('cs-CZ', { weekday: short ? "short" : "long" });
    return weekDayFormatter.format(new Date(dateTime * 1000));
}

export function isMonday(dateTime: DateTime) {
    return getWeekDay(dateTime) === 1;
}

export function addMinute(dateTime: DateTime, minutes: number = 1) {
    return dateTime + minutes * minuteForDateTime;
}
export function addHour(dateTime: DateTime, hours: number = 1) {
    return dateTime + hours * hourForDateTime;
}
export function addDay(dateTime: DateTime, days: number = 1) {
    return dateTime + days * dayForDateTime;
}

export function startDay(dateTime: DateTime) {
    return Math.floor(dateTime / dayForDateTime) * dayForDateTime;
}

export const secondForDateTime = 1
export const minuteForDateTime = 60 * secondForDateTime;
export const hourForDateTime = 60 * minuteForDateTime;
export const dayForDateTime = 24 * hourForDateTime;
export const weekForDateTime = 7 * dayForDateTime;
export const monthForDateTime = 30 * dayForDateTime;
export const yearForDateTime = 365 * dayForDateTime;